import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
  setIsOpenAddDialog,
  setIsOpenEditDialog,
} from "src/redux/slices/BannerSlice";
import CMSBannerListing from "./CMSBannerListing";
import { useGetCMSByTypeQuery } from "src/services/CMSService";
import EditBannerFormWrapper from "../Edit/EditBannerFormWrapper";
import AddBannerFormWrapper from "../Add/AddBannerFormWrapper";

type Props = {};

const CMSBannerListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const {
    items,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    isTableLoading,
    issOpenAddDialog,
    isOpenEditDialog,
  } = useSelector((state: RootState) => state.banner);

  const { data, isLoading, isFetching }: any = useGetCMSByTypeQuery("BANNER");
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
  }, [data, isLoading, isFetching, dispatch]);

  return (
    <div>
      <CMSBannerListing
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setIsOpenAddDialog: (value) => dispatch(setIsOpenAddDialog(value)),
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
        onEdit={() => {
          dispatch(setIsOpenEditDialog(true));
        }}
      />

      {isOpenEditDialog && (
        <EditBannerFormWrapper
          onClose={() => {
            dispatch(setIsOpenEditDialog(false));
          }}
        />
      )}
      {issOpenAddDialog && (
        <AddBannerFormWrapper
          onClose={() => {
            dispatch(setIsOpenAddDialog(false));
          }}
        />
      )}
    </div>
  );
};

export default CMSBannerListingWrapper;
